// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + "4d3409df" + "." + "60617b39d9f72bab" + ".js";
};